export default __webpack_public_path__ + "static/media/Longblade of the Sea.2925976e.jpg";